// extracted by mini-css-extract-plugin
module.exports = {"root":"PaymentsMobile_root__34k6z","item":"PaymentsMobile_item__1l07s","label":"PaymentsMobile_label__3L-_r","amount":"PaymentsMobile_amount__vfAXb"};